import {AccessLevel} from "@views/configurations/enums/accessLevel";
import { accessLevelOrder } from '@utils/accessHelper';

export function canAccessAction(store, actionName, requiredLevel = AccessLevel.READER) {
    if (!store || !store.getters) {
        return false;
    }

    const profile = store.getters.getProfile;
    if (!profile || !Array.isArray(profile.screen_action_permissions)) {
        return false;
    }

    const permissions = profile.screen_action_permissions;
    const userPermission = permissions.find(p => p.action === actionName);

    if (!userPermission) return false;

    const userLevel = accessLevelOrder[userPermission.access_level] || 0;
    const required = accessLevelOrder[requiredLevel] || 0;

    return userLevel >= required;
}
